<template>
  <div class="mb-4">
    <p class="text-sm font-semibold text-argus-forest-300 mb-2">{{ question }}</p>
    <div class="flex gap-2">
      <button
        type="button"
        class="px-5 py-1.5 rounded-md text-sm font-semibold border transition-opacity"
        :class="modelValue === true
          ? 'bg-argus-forest-100 text-argus-forest-950 border-transparent'
          : 'bg-white/10 text-argus-forest-100 border-transparent opacity-70 hover:opacity-90'"
        @click="$emit('update:modelValue', true)"
      >Yes</button>
      <button
        type="button"
        class="px-5 py-1.5 rounded-md text-sm font-semibold border transition-opacity"
        :class="modelValue === false
          ? 'bg-argus-forest-100 text-argus-forest-950 border-transparent'
          : 'bg-white/10 text-argus-forest-100 border-transparent opacity-70 hover:opacity-90'"
        @click="$emit('update:modelValue', false)"
      >No</button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    question: { type: String, required: true },
    modelValue: { type: Boolean, default: null },
  },
  emits: ['update:modelValue'],
}
</script>